import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import { Text } from '@cuemath/comps';
import { FONT_FAMILY } from 'constants/font';

const SelectStyle = styled(Select)`
  font-family: ${FONT_FAMILY};
`;

export default function SelectInput({
  onChange,
  label,
  options,
  value,
  disabled,
  isMulti,
  ...other
}) {
  return (
    <>
      <Text>{label}</Text>
      <div className="select-container">
        <SelectStyle
          options={options}
          onChange={onChange}
          value={value}
          isDisabled={disabled}
          isMulti={isMulti}
          {...other}
        />
      </div>
    </>
  );
}
SelectInput.defaultProps = {
  label: null,
  value: null,
  onChange: () => {},
};
SelectInput.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  onChange: PropTypes.func,
};
